//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
		return {
			urlToShare: this.$nuxt.$route.path,
			post:  this.$store.state.post,
		}
	},
}
